const SHOW_IN_CATALOG_DEFAULT_VALUE = false

module.exports = {
  SHOW_IN_CATALOG_DEFAULT_VALUE,
}
